document.addEventListener("DOMContentLoaded", function () {
  const btnSlitting = document.querySelector(".btn-slitting");
  const modal = document.getElementById("modal-cuts");
  const overlay = document.querySelector(".overlay");
  const promptModal = document.getElementById("modal-cuts-prompt");
  const addToCartBtn = promptModal.querySelector(".cuts-prompt__btn--atc");
  const discardBtn = promptModal.querySelector(".cuts-prompt__btn--discard");
  const rollContainer = document.getElementById("roll-container");

  // Declare variables for dynamic data
  let feeProductId = rollContainer.dataset.feeId;
  let feeProductPrice = parseInt(rollContainer.dataset.feeCost);
  let rollWidth = parseFloat(rollContainer.dataset.rollWidth);
  let rollLength = rollContainer.dataset.rollLength;

  let cuts = [];

  // Listen for Shopify variant change event
  document.addEventListener("variant:change", function (event) {
    const variant = event.detail.variant;
    if (!variant) return;

    // Find size option (assuming it's the "Size" option)
    const sizeOption = variant.options.find(opt => opt.includes("x"));
    if (sizeOption) {
      const width = sizeOption.split(" x ")[0].replace("in", "").trim();
      const length = sizeOption.split(" x ")[1].replace("yds", "").trim();

      rollWidth = parseFloat(width);
      rollLength = parseFloat(length);

      // Update modal data attributes
      rollContainer.dataset.rollWidth = rollWidth;
      rollContainer.dataset.rollLength = rollLength;

      // Update visual cylinder text if modal is open
      const cylinderLabel = rollContainer.querySelector(".cylinder__length");
      if (cylinderLabel) {
        cylinderLabel.textContent = `${rollWidth} in x ${rollLength} yds`;
      }

      console.log(`Updated roll width: ${rollWidth}, roll length: ${rollLength}`);
    }
  });

  function openModal() {
    // Re-fetch latest values before generating slices
    rollWidth = parseFloat(rollContainer.dataset.rollWidth);
    rollLength = rollContainer.dataset.rollLength;

    // Update visible cylinder label text (if it exists)
    const cylinderLabel = rollContainer.querySelector(".cylinder__length");
    if (cylinderLabel) {
      cylinderLabel.textContent = `${rollWidth} in x ${rollLength} yds`;
      // console.log("Updated modal text →", `${rollWidth} in x ${rollLength} yds`);
    }

    // Open modal and regenerate slices using latest values
    modal.setAttribute("open", "");
    overlay.classList.add("is-visible");
    generateSlices();
  }

  function closeModal() {
    modal.removeAttribute("open");
    overlay.classList.remove("is-visible");
  }

  function openPrompt() {
    promptModal.style.display = "block";
    renderCutList();
  }

  function closePrompt() {  
    cuts = [];
    renderCutList();
    document.querySelectorAll(".slice--selected").forEach(el => el.classList.remove("slice--selected"));
    const costEl = document.getElementById('cuts__cost_price');
    if (costEl) costEl.innerHTML = `$0 USD`;
  }

  function generateSlices() {
    rollContainer.innerHTML = "";

    const sliceCount = Math.floor(rollWidth * 4);
    const cylinder = document.createElement("div");
    cylinder.className = "cylinder";

    const cylinderLength = document.createElement("div");
    cylinderLength.className = "cylinder__length";
    cylinderLength.textContent = `${rollWidth} in x ${rollLength} yds`;

    const cylinderWidth = `calc((${sliceCount + 1} * var(--slice-width)) + 6px)`;
    const totalWidth = `calc((${sliceCount + 1} * var(--slice-width)) + 6px + var(--cylinder-right-gutter))`;
    cylinder.style.width = totalWidth;

    cylinder.appendChild(cylinderLength);
    rollContainer.appendChild(cylinder);

    const sheet = document.createElement("div");
    sheet.classList.add("sheet");
    sheet.style.width = cylinderWidth;

    if (rollWidth > 29) {
      sheet.style.left = "30px";
    }

    for (let i = 0; i <= rollWidth * 4; i++) {
      const inch = parseFloat((i * 0.25).toFixed(2));
      const slice = document.createElement("div");
      slice.classList.add("slice");
      slice.dataset.inch = inch.toFixed(2);

      if (inch <= 2.25 || inch >= rollWidth - 2.25) slice.classList.add("slice--edge");
      if (inch % 1 === 0) slice.classList.add("slice--marked");

      if (i === 0) {
        slice.classList.add("slice--marked-start");
        slice.classList.remove("slice--marked");
      } else if (i === Math.round(rollWidth * 4)) {
        slice.classList.add("slice--marked-end");
        slice.classList.remove("slice--marked");
      }

      const interact = document.createElement("div");
      interact.className = "slice__interact";

      const info = document.createElement("div");
      info.className = "slice__info";

      const current = document.createElement("div");
      current.className = "slice__info-current";
      current.textContent = `${inch}"`;

      const distances = document.createElement("div");
      distances.className = "slice__distances";

      const behind = document.createElement("div");
      behind.className = "slice__distances-behind";

      const ahead = document.createElement("div");
      ahead.className = "slice__distances-ahead";

      distances.appendChild(behind);
      distances.appendChild(ahead);
      info.appendChild(current);
      info.appendChild(distances);
      interact.appendChild(info);
      slice.appendChild(interact);

      slice.addEventListener("click", () => handleSliceClick(inch));
      sheet.appendChild(slice);
    }

    rollContainer.appendChild(sheet);
  }

  function handleSliceClick(inch) {
    inch = parseFloat(inch);
    if (inch < 2.25 || inch > (rollWidth - 2.25)) {
      showCutError(inch, "Cut must be at least 2.25\" from edge");
      return;
    }

    for (let cut of cuts) {
      if (Math.abs(cut - inch) < 2.25) {
        showCutError(inch, "Cannot create a cut within 2.25\" of another");
        return;
      }
    }

    cuts.push(inch);
    cuts.sort((a, b) => a - b);

    const selectedEl = document.querySelector(`.slice[data-inch="${inch.toFixed(2)}"]`);
    if (selectedEl) selectedEl.classList.add("slice--selected");

    renderCutList();
    openPrompt();
  }

  function showCutError(inch, msg) {
    const slice = document.querySelector(`.slice[data-inch="${inch.toFixed(2)}"]`);
    if (!slice) return;
    slice.classList.add("slice--error");
    setTimeout(() => slice.classList.remove("slice--error"), 2000);
    showToast(msg);
  }

  function renderCutList() {
    const oldButtons = rollContainer.querySelectorAll(".cut-btn");
    oldButtons.forEach(el => el.remove());

    if (cuts.length > 0) {
      const totalCost = (cuts.length * feeProductPrice / 100).toFixed(2);
      document.getElementById('cuts__cost_price').innerHTML = `$${totalCost} USD`;

      cuts.forEach((cut, index) => {
        const btn = document.createElement("button");
        btn.className = "cut-btn";
        btn.type = "button";
        btn.style.left = `calc(${cut * 4} * var(--slice-width))`;

        const number = document.createElement("span");
        number.className = "cut-btn__number";
        number.textContent = index + 1;

        const cutText = document.createElement("span");
        cutText.className = "cut-btn__cut";
        cutText.textContent = `Cut of ${cut}"`;

        const del = document.createElement("span");
        del.className = "cut-btn__delete";
        del.textContent = "×";

        del.addEventListener("click", () => {
          cuts = cuts.filter(c => c !== cut);
          const slice = document.querySelector(`.slice[data-inch="${cut.toFixed(2)}"]`);
          if (slice) slice.classList.remove("slice--selected");
          renderCutList();
        });

        btn.appendChild(number);
        btn.appendChild(cutText);
        btn.appendChild(del);
        rollContainer.appendChild(btn);
      });
    }
  }

  function showToast(msg) {
    const toast = document.createElement("div");
    toast.className = "toast absolute toast--warning toast--show";
    toast.innerHTML = `<div class="toast__content">${msg}</div>`;
    document.querySelector('.custom-vinyl-slitting-drawer').appendChild(toast);
    setTimeout(() => toast.remove(), 4000);
  }

  function submitCutsToCart() {
    if (cuts.length === 0) {
      showToast("Please add at least one cut before proceeding.");
      return;
    }

    var date = new Date();
    var time = date.getTime();

    const properties = {
      "_Vinyl Cuts": cuts.map((cut, i) => `[${i + 1}] ${cut}`).join(";"),
      "_timeTrack": time
    };

    const mainProductId = document.querySelector(".cuts-prompt__btn--atc")?.getAttribute("data-main-product-id");
    if (!mainProductId) {
      showToast("Main product ID not found.");
      return;
    }

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: feeProductId,
        quantity: cuts.length,
        properties: { "_timeTrack": time }
      })
    })
      .then(res => {
        if (!res.ok) throw new Error("Failed to add slitting fee product");
        return fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: mainProductId,
            quantity: 1,
            properties: properties
          })
        });
      })
      .then(res => {
        if (!res.ok) throw new Error("Failed to add main product");
        return res.json();
      })
      .then(() => {
        window.location.href = "/cart";
      })
      .catch(err => {
        console.error("Error:", err);
        showToast(err.message || "Something went wrong while adding to cart.");
      });
  }

  // Bind event listeners
  btnSlitting.addEventListener("click", openModal);
  discardBtn.addEventListener("click", closePrompt);
  addToCartBtn.addEventListener("click", submitCutsToCart);
  modal.querySelector(".modal-close").addEventListener("click", closeModal);
});

// =========================

window.updateProductCuts = function(customSelectEl) {

  if (!customSelectEl) {
    console.warn('No custom select element passed!');
    return;
  }

  //  Get the selected <li> option
  const selectedOption = customSelectEl.querySelector('[aria-selected="true"]');
  if (!selectedOption) return;

  const selectedValue = selectedOption.dataset.value.trim();
  // console.log('Full selected value:', selectedValue);

  // Extract both numeric values (e.g. "36 in x 50 yds" → ["36", "50"])
  const numbers = selectedValue.match(/\d+(\.\d+)?/g);

  if (numbers && numbers.length >= 2) {
    const width = numbers[0];
    const length = numbers[1];

    //  Update #roll-container dataset attributes
    const rollContainer = document.getElementById('roll-container');
    if (rollContainer) {
      rollContainer.dataset.rollWidth = width;
      rollContainer.dataset.rollLength = length;
      // console.log(`data-roll-width: ${width}, data-roll-length: ${length}`);
    }

    //  Update visible cylinder label text (only size value)
    const cylinderLabel = document.querySelector('.cylinder__length');
    if (cylinderLabel) {
      cylinderLabel.textContent = selectedValue; 
      // console.log('Updated .cylinder__length text:', selectedValue);
    }

  } else {
    console.warn('Could not extract both dimensions from:', selectedValue);
  }
};


// document.addEventListener("DOMContentLoaded", function () {
//   const btnSlitting = document.querySelector(".btn-slitting");
//   const modal = document.getElementById("modal-cuts");
//   const overlay = document.querySelector(".overlay");
//   const promptModal = document.getElementById("modal-cuts-prompt");
//   const addToCartBtn = promptModal.querySelector(".cuts-prompt__btn--atc");
//   const discardBtn = promptModal.querySelector(".cuts-prompt__btn--discard");

//   const rollContainer = document.getElementById("roll-container");
//   const feeProductId = rollContainer.dataset.feeId;
//   const feeProductPrice = parseInt(rollContainer.dataset.feeCost);
//   const rollWidth = parseFloat(rollContainer.dataset.rollWidth);
//   const rollLength = rollContainer.dataset.rollLength;

//   let cuts = [];

//   function openModal() {
//     modal.setAttribute("open", "");
//     overlay.classList.add("is-visible");
//     generateSlices();
//   }

//   function closeModal() {
//     modal.removeAttribute("open");
//     overlay.classList.remove("is-visible");
//   }

//   function openPrompt() {
//     promptModal.style.display = "block";
//     renderCutList();
//   }

//   function closePrompt() {  
//     // Reset cuts
//     cuts = [];
//     renderCutList();
//     // Remove all .slice--selected classes
//     document.querySelectorAll(".slice--selected").forEach(el => {
//       el.classList.remove("slice--selected");
//     });  
      
//     // Optionally reset subtotal to $0
//     const costEl = document.getElementById('cuts__cost_price');
//     if (costEl) costEl.innerHTML = `$00 USD`;
    
//   }

//   function generateSlices() {
//     rollContainer.innerHTML = "";

//     const sliceCount = Math.floor(rollWidth * 4);
//     const cylinder = document.createElement("div");
//     cylinder.className = "cylinder";

//     const cylinderLength = document.createElement("div");
//     cylinderLength.className = "cylinder__length";
//     cylinderLength.textContent = `${rollWidth} in x ${rollLength} yds`;

//     const cylinderWidth = `calc((${sliceCount + 1} * var(--slice-width)) + 6px)`;
//     const totalWidth = `calc((${sliceCount + 1} * var(--slice-width)) + 6px + var(--cylinder-right-gutter))`;
//     cylinder.style.width = totalWidth;

//     cylinder.appendChild(cylinderLength);
//     rollContainer.appendChild(cylinder);

//     const sheet = document.createElement("div");
//     sheet.classList.add("sheet");
//     sheet.style.width = cylinderWidth;

//     for (let i = 0; i <= rollWidth * 4; i++) {
//       const inch = parseFloat((i * 0.25).toFixed(2));
//       const slice = document.createElement("div");
//       slice.classList.add("slice");
//       slice.dataset.inch = inch.toFixed(2);

//       if (inch <= 2.25 || inch >= rollWidth - 2.25) {
//         slice.classList.add("slice--edge");
//       }

//       if (inch % 1 === 0) {
//         slice.classList.add("slice--marked");
//       }

//       if (i === 0) {
//         slice.classList.add("slice--marked-start");
//         slice.classList.remove("slice--marked");
//       } else if (i === Math.round(rollWidth * 4)) {
//         slice.classList.add("slice--marked-end");
//         slice.classList.remove("slice--marked");
//       }

//       const interact = document.createElement("div");
//       interact.className = "slice__interact";

//       const info = document.createElement("div");
//       info.className = "slice__info";

//       const current = document.createElement("div");
//       current.className = "slice__info-current";
//       current.textContent = `${inch}"`;

//       const distances = document.createElement("div");
//       distances.className = "slice__distances";

//       const behind = document.createElement("div");
//       behind.className = "slice__distances-behind";

//       const ahead = document.createElement("div");
//       ahead.className = "slice__distances-ahead";

//       distances.appendChild(behind);
//       distances.appendChild(ahead);
//       info.appendChild(current);
//       info.appendChild(distances);
//       interact.appendChild(info);
//       slice.appendChild(interact);

//       slice.addEventListener("click", () => handleSliceClick(inch));
//       sheet.appendChild(slice);
//     }

//     rollContainer.appendChild(sheet);
//   }

//   function handleSliceClick(inch) {
//     inch = parseFloat(inch);
  
//     // ❌ Prevent cut within 2.25" of start or end
//     if (inch < 2.25 || inch > (rollWidth - 2.25)) {
//       showCutError(inch, "Cut must be at least 2.25\" from edge");
//       return;
//     }
  
//     // ❌ Prevent cut within 2.25" of another existing cut
//     for (let cut of cuts) {
//       if (Math.abs(cut - inch) < 2.25) {
//         showCutError(inch, "Cannot create a cut within 2.25\" of another");
//         return;
//       }
//     }
  
//     // ✅ Valid cut — store and mark
//     cuts.push(inch);
//     cuts.sort((a, b) => a - b);
  
//     const selectedEl = document.querySelector(`.slice[data-inch="${inch.toFixed(2)}"]`);
//     if (selectedEl) selectedEl.classList.add("slice--selected");
  
//     renderCutList();
//     openPrompt();
//   }


//   function showCutError(inch) {
//     const slice = document.querySelector(`.slice[data-inch="${inch.toFixed(2)}"]`);
//     if (!slice) return;

//     slice.classList.add("slice--error");
//     setTimeout(() => slice.classList.remove("slice--error"), 2000);

//     showToast("Cannot create a cut within 2.25\" of another");
//   }

//   function renderCutList() {
//     // Remove previous cut buttons from rollContainer
//     const oldButtons = rollContainer.querySelectorAll(".cut-btn");
//     oldButtons.forEach(el => el.remove());
  
//     if (cuts.length > 0) {
//       const totalCost = (cuts.length * feeProductPrice / 100).toFixed(2);    
//       document.getElementById('cuts__cost_price').innerHTML = `$${totalCost} USD`;    

//       cuts.forEach((cut, index) => {
//         const btn = document.createElement("button");
//         btn.className = "cut-btn";
//         btn.type = "button";
//         btn.style.left = `calc(${cut * 4} * var(--slice-width))`; // Position based on inch

//         const number = document.createElement("span");
//         number.className = "cut-btn__number";
//         number.textContent = index + 1;

//         const cutText = document.createElement("span");
//         cutText.className = "cut-btn__cut";
//         cutText.textContent = `Cut of ${cut}"`;

//         const del = document.createElement("span");
//         del.className = "cut-btn__delete";
//         del.textContent = "×";

//         del.addEventListener("click", () => {
//           // Remove from array
//           cuts = cuts.filter(c => c !== cut);

//           // Remove selected highlight from slice
//           const slice = document.querySelector(`.slice[data-inch="${cut.toFixed(2)}"]`);
//           if (slice) {
//             slice.classList.remove("slice--selected");
//           }

//           // Re-render
//           renderCutList();
//         });

//         btn.appendChild(number);
//         btn.appendChild(cutText);
//         btn.appendChild(del);

//         rollContainer.appendChild(btn); // Append to ruler
//       });
//     }  
//   }


//   function showToast(msg) {
//     console.log('enter');
//     const toast = document.createElement("div");
//     toast.className = "toast absolute toast--warning toast--show";
//     toast.innerHTML = `<div class="toast__content">${msg}</div>`;
//     document.querySelector('.custom-vinyl-slitting-drawer').appendChild(toast);

//     setTimeout(() => toast.remove(), 4000);
//   }

//   function submitCutsToCart() {
//     if (cuts.length === 0) {
//       showToast("Please add at least one cut before proceeding.");
//       return;
//     }
//     var date = new Date();
//     var time = date.getTime();

//     const properties = {
//       "Slitted": cuts.map((cut, i) => `[${i + 1}] ${cut}`).join(";"),
//       "_timeTrack": time
//     };

//     const mainProductId = document.querySelector(".cuts-prompt__btn--atc")?.getAttribute("data-main-product-id");
//     if (!mainProductId) {
//       showToast("Main product ID not found.");
//       return;
//     }

//     // Step 1: Add Fee Product
//     fetch("/cart/add.js", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         id: feeProductId,
//         quantity: cuts.length,
//         properties : {
//           "_timeTrack": time
//         }
//       })
//     })
//     .then(res => {
//       if (!res.ok) throw new Error("Failed to add slitting fee product");

//       // Step 2: Add Main Product with Vinyl Cuts as line item property
//       return fetch("/cart/add.js", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           id: mainProductId,
//           quantity: 1,
//           properties: properties
//         })
//       });
//     })
//     .then(res => {
//       if (!res.ok) throw new Error("Failed to add main product");
//       return res.json();
//     })
//     .then(() => {
//       window.location.href = "/cart";
//     })
//     .catch(err => {
//       console.error("Error:", err);
//       showToast(err.message || "Something went wrong while adding to cart.");
//     });
//   }



//   btnSlitting.addEventListener("click", openModal);
//   discardBtn.addEventListener("click", closePrompt);
//   addToCartBtn.addEventListener("click", submitCutsToCart);
//   modal.querySelector(".modal-close").addEventListener("click", closeModal);
// });
